import {useAlgoliaShopConfig} from "@/providers/AlgoliaShopConfigProvider.tsx";
import type {AlgoliaAutocompleteHit} from "@/types/AlgoliaAutocompleteHit.ts";
import type {AutocompletePlugin} from "@algolia/autocomplete-core";
import {getAlgoliaResults} from "@algolia/autocomplete-preset-algolia";
import type {FacetFilters, SearchResponse} from "algoliasearch";
import type {RefObject} from "react";

export const useProductPlugin = (  filtersRef: RefObject<string>,
                                   facetFiltersRef: RefObject<FacetFilters>)=> {
    const {
        searchClient,
        algoliaConfig: { algoliaIndexName, autocompleteProductHits },
    } = useAlgoliaShopConfig();
    const productsPlugin: AutocompletePlugin<AlgoliaAutocompleteHit, {}> = {
        getSources({query}) {
            if (!query) {
                return [];
            }
            return [
                {
                    sourceId: 'productsPlugin',
                    getItems({setContext}) {
                        return getAlgoliaResults<AlgoliaAutocompleteHit>({
                            searchClient,
                            queries: [
                                {
                                    indexName: algoliaIndexName,
                                    params: {
                                        query,
                                        hitsPerPage:autocompleteProductHits,
                                        filters:filtersRef.current,
                                        facetFilters:facetFiltersRef.current,
                                    },
                                },
                            ],
                            transformResponse({hits, results}) {
                                setContext({
                                    nbProducts: (results[0] as SearchResponse<AlgoliaAutocompleteHit>).nbHits,
                                });
                                return hits;
                            },
                        });
                    },
                },
            ];
        },
    };
    return productsPlugin;
}
